import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.links = Array.from(this.element.querySelectorAll('a[href^="#"]'))
    this.update()
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
    this.frame = null
  }

  navigate(event) {
    const link = event.target.closest("a")
    if (!this.links.includes(link)) return
    event.preventDefault()
    const section = this.section(link)
    if (!section) return
    section.scrollIntoView({ behavior: "smooth", block: "start" })
    this.highlight(link)
  }

  schedule() {
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.update()
    })
  }

  update() {
    const position = window.scrollY + 100
    const active = this.links.filter(link => {
      const section = this.section(link)
      return section && section.offsetTop <= position
    }).at(-1)
    this.highlight(active)
  }

  section(link) {
    return document.getElementById(link.getAttribute("href").slice(1))
  }

  highlight(active) {
    this.links.forEach(link => link.classList.toggle("active", link === active))
  }
}
